/*
 * Copyright (c) 2016-2018 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component} from '@angular/core';
export class DatagridColumnToggleTitle {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-dg-column-toggle-title",
    template: `<ng-content></ng-content>`,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatagridColumnToggleTitle_tsickle_Closure_declarations() {
/** @type {?} */
DatagridColumnToggleTitle.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridColumnToggleTitle.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
